import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React, { Fragment } from 'react';
import { CheckboxFilter, TextInputFilter, FiltersContainer, SortsContainer, ViewToggle, ActiveFiltersDescription, FiltersRestore } from '../../Filter';
import { Inner, InnerWrapper } from './partials';
import { getOrdersOptions } from './utils';
export var ManagementCompaniesFilters = function ManagementCompaniesFilters(_ref) {
  var search = _ref.search,
    onSearchChange = _ref.onSearchChange,
    onOrderChange = _ref.onOrderChange,
    onRestore = _ref.onRestore,
    order = _ref.order,
    orders = _ref.orders,
    view = _ref.view,
    onViewChange = _ref.onViewChange,
    qty = _ref.qty,
    totalItems = _ref.totalItems;
  var handleSearchReturn = onSearchChange ? onSearchChange : function () {};
  var handleOrderReturn = onOrderChange ? onOrderChange : function () {};
  var handleRestore = onRestore ? onRestore : function () {};
  var noActiveFilters = !search.length;
  return React.createElement(Inner, null, React.createElement(InnerWrapper, null, React.createElement(FiltersContainer, null, React.createElement(TextInputFilter, {
    search: search,
    placeholder: search || 'Buscar',
    title: "Buscar por nombre de la gestora",
    onReturn: handleSearchReturn
  }), React.createElement(FiltersRestore, {
    width: "auto",
    onClick: handleRestore,
    hidden: noActiveFilters
  }, "Restablecer")), React.createElement(SortsContainer, null, React.createElement(CheckboxFilter, {
    right: true,
    placeholder: order ? order.label : 'Ordenar por',
    title: "Ordenar  por...",
    options: getOrdersOptions(orders),
    onReturn: handleOrderReturn,
    initialValue: [{
      id: order
    }]
  }), React.createElement(ViewToggle, {
    view: view,
    onClick: onViewChange
  }))), React.createElement(ActiveFiltersDescription, null, "Est\xE1s viendo ", qty, " gestoras", qty < totalItems ? React.createElement(Fragment, null, " de ", totalItems) : null, search.length ? React.createElement(Fragment, null, " que coinciden con la b\xFAsqueda \"", search, "\"") : null, "."));
};